var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-footer',{staticClass:"pa-3",attrs:{"app":""}},[_c('v-layout',{attrs:{"justify-center":""}},[_c('span',{staticClass:"schuberth_main--text"},[_vm._v("© "+_vm._s(new Date().getFullYear())+" SCHUBERTH GmbH")])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }